import React from "react";
import { PortalFormacionContainer } from "./portal-formacion-style";
import Title02Text from "../../components/components-text/title-02-text";
import { CardGrid } from "./components/CardGrid";

import "./components/cards.css";
import PortalFormacionServices from "../../services/PortalFormacionServices";

interface PortalFormacionProps {}

interface PortalFormacionState {
  items: any[];
  loading: boolean;
  error: any;
}

export default class PortalFormacionLayout extends React.Component<
  PortalFormacionProps,
  PortalFormacionState
> {
  constructor(props: PortalFormacionProps) {
    super(props);

    this.state = {
      items: [],
      loading: false,
      error: null,
    };
  }

  // Método que tu servicio espera recibir
  setLoading = (value: boolean) => {
    this.setState({ loading: value });
  };

  async componentDidMount() {
    try {
      const user: any = localStorage.getItem('loggedUser');
      const parsedUser = JSON.parse(user)
      const data = await PortalFormacionServices.getList(
        this.setLoading,
        true,
        parsedUser.code
      );
      this.setState({ items: data });
    } catch (err) {
      this.setState({ error: err || "Error desconocido" });
    }
  }

  render() {
    const { items, loading, error } = this.state;

    return (
      <>
        <PortalFormacionContainer>
          <div className="main-title-container">
            <Title02Text>
              <h2>Portal de Formación</h2>
            </Title02Text>
          </div>

          <h3>Elija el enlace al que quiere acceder.</h3>

          {loading && <p>Cargando…</p>}
          {error && <p style={{ color: "crimson" }}>{error}</p>}
        </PortalFormacionContainer>

        <CardGrid items={items} />
      </>
    );
  }
}